module.exports = __webpack_public_path__ + "static/img/advertising10.034b5c49.png";